import { render, staticRenderFns } from "./point-symbol.vue?vue&type=template&id=35f3e104&scoped=true"
import script from "./point-symbol.vue?vue&type=script&lang=js"
export * from "./point-symbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3e104",
  null
  
)

export default component.exports